import React, { FC } from 'react';
import styled from 'styled-components';

import { CompleteStatusEnum } from '~/api/book/bookApiTypes';
import { Cycle } from '~/api/book/cycleApiTypes';
import { CycleLink } from '~/atomic/atom/links/dynamicLinks';
import { BookStatus } from '~/atomic/molecula/BookStatus';
import { authorSelector } from '~/atomic/page/author/author.selector';
import { TextRegStyle } from '~/atomic/Typography';
import { defaultCycleName, isHaveCyclesWithBooksSelector } from '~/feature/cycle/cycleSlice';
import { useAppSelector } from '~/store';

export const CycleTitle: FC<{ cycle: Cycle }> = ({ cycle }) => {
  const isHaveCycles = useAppSelector(isHaveCyclesWithBooksSelector);
  const isDefaultCycle = cycle.name === defaultCycleName;
  const { currentAuthor } = useAppSelector(authorSelector);
  const {
    name, numbersOfBooks, slug,
  } = cycle;

  if (!isHaveCycles && isDefaultCycle) {
    return null;
  }

  if (isDefaultCycle) {
    return (
      <SCCycleWrapper>
        <SCCycleLabel>Другие произведения</SCCycleLabel>
      </SCCycleWrapper>
    );
  }

  return (
    <SCCycleWrapper>
      <CycleLink authorUsername={currentAuthor.username} slug={slug}>
        <SCAnchorLink>
          <SCCycleName>
            Серия книг
            {' '}
            {name}
          </SCCycleName>
        </SCAnchorLink>
      </CycleLink>
      <SCCycleLabel>
        {` (${numbersOfBooks}) `}
      </SCCycleLabel>
      {cycle.complete && (
        <BookStatus
          type={CompleteStatusEnum.Complete}
          text="завершен"
        />
      )}

    </SCCycleWrapper>
  );
};

const SCCycleLabel = styled.span`
  ${TextRegStyle};
  color: var(--gray-color);
  margin: 0 5px;
`;

const SCCycleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const SCAnchorLink = styled.a`
  ${TextRegStyle};
  text-decoration: none;
  color: var(--black-color);

  &:hover {
    text-decoration: none;
    color: var(--primary-hover-color);
  }
  
  &:visited {
    text-decoration: none;
    color: var(--primary-hover-color);
  }
`;

const SCCycleName = styled.h2`
  font-size: inherit;
  line-height: inherit;
  margin: inherit;
  font-family: inherit;
  color: inherit;
  font-weight: inherit;
`;
